<template>
<p class="text-small contact__loggedin" v-if="loggedIn">
  Angemeldet als: {{ username }}
</p>
</template>

<script>
export default {
  name: "ContactLoggedIn",

  computed: {
    loggedIn() {
      return this.$store.state.user.loggedIn;
    },

    username() {
      return this.$store.state.user.email;
    }
  }

};
</script>

